/* MTX — Roulette « tomette au prénom à 10 € » (page panier, section mtx-roulette).
   Conditions : le panier contient au moins une autre pièce et un prénom de la liste des
   prénoms référencés (prenoms.json) a été trouvé dans une personnalisation ; l'offre n'est pas
   déjà au panier. Le prix réel est appliqué par une remise automatique Shopify : la roue
   ne fait que révéler l'offre — chaque case est gagnante.
   La tomette est dessinée par le moteur guidé de la fiche d'offre, chargé dans une iframe
   (?view=mtp-render) : grande dès l'ouverture, nette en vue agrandie (le moteur redessine son
   canevas à la taille de la tuile), avec l'option trou de suspension (variante « Percée »).
   L'ajout au panier clique le bouton du moteur (prénom, phrase, aperçu PNG, recette et SVG de
   gravure joints), avec un ajout de secours direct ; jamais deux lignes d'offre.
   Trois mises en page posées en JS sur .mtxr-fond : data-mise = feuille | carte | colonnes,
   data-hauteur = haut | moyen | bas. L'iframe reste toujours sous 760 px de large au chargement
   (au-delà, le moteur active sa télémétrie de bureau). */
(function(){
  'use strict';
  var cfgEl = document.getElementById('mtxRouletteCfg'); if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch(e) { return; }
  var T = C.txt || {}, O = C.offre || {};
  var test = /[?&]mtxr=test\b/.test(location.search) && !(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  /* thème non publié (aperçu) : options en relecture visibles même décochées */
  var relecture = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  var actif = !!(C.actif || test); /* la garde « jamais seule » tourne même roue éteinte */
  var SRC = 'https://admin.mytomette.fr/json/prenoms.json';
  function euros(c){
    c = Math.round(Number(c) || 0);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100); }
    catch(e) { return (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(c / 100)) + ' €'; }
  }
  /* prix d'offre avec trou : fourni par la section (prix de la Percée − la même remise fixe) */
  if (O.variantPercee && O.barrePerceeCents && O.prixPerceeCents == null) O.prixPerceeCents = O.barrePerceeCents - (O.barreCents - O.prixCents);
  /* trou : case « trou » de la section (décochée tant que l'atelier n'a pas validé la position du prénom) */
  O.trouOk = !!((C.trou || relecture) && O.variantPercee && O.barrePerceeCents > O.barreCents && O.prixPerceeCents > 0);
  O.prix = euros(O.prixCents); O.prixBarre = euros(O.barreCents);
  var CLE = 'mtxRoulette:ferme';
  function lireS(k){ try { return sessionStorage.getItem(k); } catch(e) { return null; } }
  function ecrireS(k, v){ try { sessionStorage.setItem(k, v); } catch(e) {} }

  /* géométrie : la tuile du moteur a un rapport verrouillé R ; l'hexagone de la photo a le rapport HEXR */
  var R = 1.1201, HEXR = 1.1115;
  var TACTILE = !!(window.matchMedia && matchMedia('(pointer:coarse)').matches);
  /* largeur max du canevas (px écran), zoom max, densité visée au zoom max (2 sur un écran Retina de bureau : lettres nettes) */
  var CAP = TACTILE ? 1536 : 4096, ZPLAF = TACTILE ? 2.5 : 3, DPRZ = TACTILE ? 1.5 : 2;
  function reduit(){ return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function borne(v, a, b){ return Math.max(a, Math.min(b, v)); }

  /* ── outils ── */
  function norm(s){
    s = String(s || '');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch(e) {}
    return s.toLowerCase().replace(/[^a-z' -]/g, '').replace(/\s+/g, ' ').trim();
  }
  function el(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function bouton(cls, txt, aria){ var b = el('button', cls, txt); b.type = 'button'; if (aria) b.setAttribute('aria-label', aria); return b; }
  var FAIBLES = /^(à|a|de|du|des|la|le|les|l'|l’|un|une|et|ou|en|au|aux|sa|son|ses|ma|mon|mes|ta|ton|tes|sur|par|pour|sans|avec|dans|qui|que|qu'|qu’|ne|n'|n’|d'|d’|se|ce|si|mais|plus|très|tout|toute)$/i;
  function cout(l){
    var lens = l.map(function(x){ return x.length; });
    var max = Math.max.apply(null, lens), moy = lens.reduce(function(a, b){ return a + b; }, 0) / lens.length;
    var c = max * 4 + (max > 23 ? (max - 23) * 15 : 0);
    lens.forEach(function(n){ c += (n - moy) * (n - moy) * 0.08; });
    for (var i = 0; i < l.length - 1; i++){
      var w = l[i].split(' '), der = w[w.length - 1];
      if (FAIBLES.test(der)) c += 50;
      if (/[,;:.!?…]$/.test(l[i])) c -= 12;
      if (l[i].length < 7) c += 10;
    }
    if (l[l.length - 1].length < 6) c += 14;
    return c;
  }
  function decouper(txt){
    txt = String(txt || '').replace(/\s+/g, ' ').trim();
    var MAX = 22, w = txt.split(' ');
    if (!txt) return [];
    if (txt.length <= MAX || w.length < 2) return [txt];
    function meilleur(n){
      if (w.length < n) return null;
      var best = null;
      (function rec(i, k, acc){
        if (k === 1){
          var c = acc.concat([w.slice(i).join(' ')]);
          var m = Math.max.apply(null, c.map(function(x){ return x.length; })), v = cout(c);
          if (!best || v < best.v) best = { m: m, v: v, l: c };
          return;
        }
        for (var j = i + 1; j <= w.length - (k - 1); j++) rec(j, k - 1, acc.concat([w.slice(i, j).join(' ')]));
      })(0, n, []);
      return best;
    }
    var b2 = meilleur(2);
    if (b2 && b2.m <= MAX) return b2.l;
    var b3 = meilleur(3);
    return (b3 || b2).l;
  }

  /* ── détection des prénoms dans les personnalisations du panier ── */
  function prenomsDuPanier(cart, data){
    var vu = {}, out = [];
    var lignes = (cart.items || []).filter(function(i){ return i.product_id !== O.productId; }).reverse();
    function scan(v){
      String(v || '').split(/[^A-Za-zÀ-ÖØ-öø-ÿ'’-]+/).forEach(function(tok){
        tok = tok.replace(/^['’-]+|['’-]+$/g, '');
        var k = norm(tok);
        if (k.length >= 2 && data[k] && !vu[k]){ vu[k] = 1; out.push(data[k]); }
      });
    }
    var EXCLUS = /^(forme|trou|per[cç]age|date|recette|aper[cç]u|gravure|modifier|source|emballage|nombre|nom de famille|nom\b)/i;
    lignes.forEach(function(l){ var p = l.properties || {}; Object.keys(p).forEach(function(k){ if (k.charAt(0) !== '_' && /pr[ée]nom|name/i.test(k)) scan(p[k]); }); });
    lignes.forEach(function(l){ var p = l.properties || {}; Object.keys(p).forEach(function(k){ if (k.charAt(0) !== '_' && !/pr[ée]nom|name/i.test(k) && !EXCLUS.test(k) && !/^https?:/.test(String(p[k]))) scan(p[k]); }); });
    return out.slice(0, 4);
  }

  /* ── état ── */
  var S = { noms: [], nom: null, phrase: 0, trou: false, ifr: null, ajout: false, etat: 'jeu', revelT: 0, essais: 0, finOk: false,
            secoursFait: false, visio: false, Z: { z: 1, cx: .5, cy: .5 }, zMax: 1, dprNatif: 1, m: null, ouvert: false, ouvertT: 0 };

  /* ── prix et textes ── */
  function tarif(trou){
    var t = !!((trou == null ? S.trou : trou) && O.trouOk);
    var b = t ? O.barrePerceeCents : O.barreCents, p = t ? O.prixPerceeCents : O.prixCents;
    return { trou: t, vid: t ? O.variantPercee : O.variantId, cents: p, barre: b, prix: euros(p), prixBarre: euros(b),
             remise: '−' + euros(b - p), sup: O.trouOk ? '+' + euros(O.barrePerceeCents - O.barreCents) : '' };
  }
  /* élision, textes français seulement (même règle que la section : lang « en » = textes anglais) :
     « de Hélène » → « d’Hélène » devant une voyelle, accents compris, ou un h (traité comme muet) */
  var FR = document.documentElement.lang !== 'en';
  function elider(s, n){
    if (!FR || !/^[AEIOUYÀÂÉÈÊËÎÏÔÙÛÜH]/i.test(String(n || '').trim())) return s;
    return s.replace(/(^|[\s\u00a0])([dD])e[ \u00a0]\{n\}/g, '$1$2\u2019{n}');
  }
  function f(s, o){
    var t = tarif(); o = o || {};
    var nb = (S.nom && S.nom.p && S.nom.p.length) || 1, n = o.n != null ? o.n : (S.nom ? S.nom.n : '');
    return elider(String(s || ''), n).replace(/\{n\}/g, n).replace(/\{p\}/g, o.p || t.prix)
      .replace(/\{b\}/g, t.prixBarre).replace(/\{i\}/g, S.phrase + 1).replace(/\{t\}/g, nb)
      .replace(/\{x\}/g, (S.nom && S.nom.p && S.nom.p[S.phrase]) || '');
  }

  /* ── aperçu : moteur guidé de la fiche d'offre dans une iframe ── */
  /* la tuile du moteur est posée en position fixe dans l'iframe et pilotée par des variables :
     largeur (--mtxw), gauche (--mtxl), haut (--mtxt). Rapport verrouillé (sinon 1,2/1 au-delà de 880 px) */
  var CSSZ = '#mtp .mtp-realphoto,#mtp .mtp-toast{display:none!important}'
    + '#mtp #mtpTile{position:fixed!important;margin:0!important;max-width:none!important;transition:none!important;'
    + 'width:var(--mtxw,min(100vw,calc(100vh*1.1201)))!important;left:var(--mtxl,50%)!important;top:var(--mtxt,50%)!important;'
    + 'transform:var(--mtxtr,translate(-50%,-50%))!important}'
    + '#mtp #mtpTile:not(.mtp-sq){aspect-ratio:1.1201/1!important}';
  function champ(doc, k){ return doc && doc.querySelector('#mtp input.mtp-fin[data-fk="' + k + '"]'); }
  /* un seul événement « change » (pas « input », qui précharge le configurateur complet) ; la casse du champ est appliquée ici */
  function pousser(w, inp, v){
    if (!inp) return; v = String(v || '');
    var cs = inp.getAttribute('data-case'); if (cs === 'upper') v = v.toUpperCase(); else if (cs === 'lower') v = v.toLowerCase();
    if (inp.value === v) return;
    inp.value = v; inp.dispatchEvent(new w.Event('change', { bubbles: true }));
  }
  function iDoc(){ try { return S.ifr && S.ifr.contentDocument; } catch(e) { return null; } }
  function iWin(){ try { return S.ifr && S.ifr.contentWindow; } catch(e) { return null; } }
  function majApercu(){
    if (!S.ifr || !S.nom) return;
    var w = iWin(), d = iDoc(); if (!w || !d) return;
    var pr = champ(d, 'prenom'); if (!pr) return;
    var l = decouper(S.nom.p[S.phrase] || '');
    try { pousser(w, pr, S.nom.n); pousser(w, champ(d, 'phrase1'), l[0] || ''); pousser(w, champ(d, 'phrase2'), l[1] || ''); pousser(w, champ(d, 'phrase3'), l[2] || ''); } catch(e) {}
  }
  /* vrai si l'état « trou » du moteur est conforme au choix du client */
  function syncTrou(w, d){
    w = w || iWin(); d = d || iDoc();
    var h = d && d.getElementById('mtpHole'), e = w && w.__MTA_ETAT__ && w.__MTA_ETAT__(), voulu = !!(S.trou && O.trouOk);
    if (!h || !e) return !voulu;
    var m = w.__MTA_CARTE__ && w.__MTA_CARTE__(); if (voulu && (!m || m.kx === 1)) return false; /* photo pas encore là : trou mal placé */
    if (!!e.hole !== voulu) h.click();
    return !!w.__MTA_ETAT__().hole === voulu;
  }
  function poserDpr(w, v){
    try {
      if (!S.dprPose){ S.dprDesc = Object.getOwnPropertyDescriptor(w, 'devicePixelRatio'); S.dprPose = 1; }
      Object.defineProperty(w, 'devicePixelRatio', { configurable: true, get: function(){ return v; } });
    } catch(e) { S.dprKo = true; }
  }
  function rendreDpr(w){
    try { if (S.dprPose){ if (S.dprDesc) Object.defineProperty(w, 'devicePixelRatio', S.dprDesc); else delete w.devicePixelRatio; S.dprPose = 0; } } catch(e) {}
  }
  /* place la tuile : l'hexagone (et non le blanc de la photo) remplit la scène ; en vue agrandie, zoom S.Z.z autour de (cx, cy) */
  function cadrer(){
    var w = iWin(), d = iDoc();
    if (!d || !w || !w.__MTA_CARTE__ || !d.documentElement) return false;
    var m; try { m = w.__MTA_CARTE__(); } catch(e) { return false; }
    if (!m || (m.kx === 1 && m.ky === 1)) return false; S.m = m;
    var Vw = S.ifr.clientWidth, Vh = S.ifr.clientHeight; if (!Vw || !Vh) return false;
    var bar = S.visio ? (TACTILE ? 64 : 72) : 0;
    var tw0 = Math.min(Vw * (S.visio ? .90 : .94) / m.kx, (Vh - 2 * bar) * .94 * R / m.ky);
    S.tw0 = tw0;
    /* zoom maximal : la ligne gravée la plus large garde 3,5 % de marge de chaque côté de l'écran */
    var zl = (S.visio && S.lg) ? .93 * Vw / (S.lg * m.kx * tw0) : Infinity;
    S.zMax = S.visio ? Math.max(1, Math.min(ZPLAF, CAP / ((S.dprKo ? S.dprNatif : Math.min(S.dprNatif, DPRZ)) * tw0), zl)) : 1;
    S.Z.z = borne(S.Z.z, 1, S.zMax);
    var tw = Math.round(tw0 * S.Z.z), th = tw / R;
    if (S.visio) poserDpr(w, Math.min(S.dprNatif, 3, CAP / tw));
    function axe(V, a0, len, c, biais){ /* biais .5 en x ; en y .44 (épaisseur et ombre sous la tomette), .36 en vue agrandie (aide et barre dessous) */
      if (len <= V) return Math.round((V - len) * biais - a0);
      return Math.round(Math.max(V - a0 - len, Math.min(-a0, V / 2 - a0 - c * len)));
    }
    var L = axe(Vw, m.x0 * tw, m.kx * tw, S.Z.cx, .5), Tt = axe(Vh, m.y0 * th, m.ky * th, S.Z.cy, S.visio ? .36 : .44);
    S.Z.cx = (Vw / 2 - L - m.x0 * tw) / (m.kx * tw); S.Z.cy = (Vh / 2 - Tt - m.y0 * th) / (m.ky * th); /* pas de zone morte */
    var st = d.documentElement.style;
    st.setProperty('--mtxw', tw + 'px'); st.setProperty('--mtxl', L + 'px'); st.setProperty('--mtxt', Tt + 'px'); st.setProperty('--mtxtr', 'none');
    S.L = L; S.T = Tt; S.tw = tw;
    return true;
  }
  /* largeur de la ligne gravée la plus large, centrée sur l'hexagone (fraction de sa largeur ; mesure du moteur) */
  function largeurLignes(){
    var w = iWin(), lg = 0;
    try {
      (w.__MTA_ETAT__().els || []).forEach(function(e){
        if (!e || e.type !== 'text' || e.__i == null) return;
        var l = Number(w.__MTA_LARGEUR__(e.__i)) || 0;
        if (l > 0) lg = Math.max(lg, l + 2 * Math.abs((e.x != null ? e.x : .5) - .5));
      });
    } catch(e) {}
    return lg;
  }
  /* point écran → fractions de l'hexagone (même repère que les gravures) */
  function versHex(x, y){
    if (!S.m || !S.tw) return null;
    var o = S.visio ? { left: 0, top: 0 } : S.ifr.getBoundingClientRect(), th = S.tw / R;
    return { x: ((x - o.left - S.L) / S.tw - S.m.x0) / S.m.kx, y: ((y - o.top - S.T) / th - S.m.y0) / S.m.ky };
  }
  /* attend que les polices de gravure soient réellement chargées (pas de rendu en police de secours) */
  function policesPretes(w, d){
    var fam = {}, t0 = Date.now();
    try {
      ((w.__MTA_ETAT__ && w.__MTA_ETAT__().els) || []).forEach(function(e){
        if (!e || e.type !== 'text' || !w.__MTA_POLICE__) return;
        var css = String(w.__MTA_POLICE__(e.font, e.weight || 600));
        var f0 = css.split(',')[0].replace(/['"]/g, '').trim(); if (f0) fam[f0] = 1;
      });
    } catch(e) {}
    var noms = Object.keys(fam);
    return new Promise(function(res){
      (function voir(){
        var faces = [], vues = {}, dt = Date.now() - t0;
        try { d.fonts.forEach(function(ff){ var n = String(ff.family).replace(/['"]/g, ''); if (fam[n]){ faces.push(ff); vues[n] = 1; } }); } catch(e) {}
        faces.forEach(function(ff){ if (ff.status === 'unloaded') try { ff.load(); } catch(e) {} });
        var finies = faces.every(function(ff){ return ff.status === 'loaded' || ff.status === 'error'; });
        if ((finies && (Object.keys(vues).length >= noms.length || dt > 600)) || dt > 2500) return res();
        setTimeout(voir, 100);
      })();
    });
  }
  /* fin d'ajout réussie du moteur : il navigue vers url('/cart') → on garde l'iframe en place et on prend la main */
  function brancherFin(w){
    var I = w && w.MT_CONFIG_I18N; if (!I || I.__mtxr || typeof I.url !== 'function') return;
    var u0 = I.url; I.__mtxr = 1;
    I.url = function(p){
      if (p === '/cart' && S.ajout && !S.finOk){ S.finOk = true; setTimeout(finMoteur, 0); return 'javascript:void 0'; }
      return u0.apply(this, arguments);
    };
  }
  function preparerApercu(){
    var pv = (location.search.match(/preview_theme_id=(\d+)/) || [])[1];
    var u = O.url + (O.url.indexOf('?') < 0 ? '?' : '&') + 'view=mtp-render' + (pv ? '&preview_theme_id=' + pv : '');
    S.apercuT0 = Date.now();
    S.koT = setTimeout(apercuKo, 12000);
    fetch(u, { credentials: 'same-origin' }).then(function(r){ if (!r.ok) throw 0; return r.text(); }).then(function(html){
      html = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + location.origin + '/"><style>' + CSSZ + '</style>');
      /* la page de rendu pose en tête une copie des données sans identifiants de variante (aperçu seul) :
         on l'écarte pour que le moteur lise les siennes, complètes, et puisse ajouter au panier */
      html = html.replace("s.id='mtpData'", "s.id='mtpDataRendu'");
      /* et son petit script de remplissage met le texte d'exemple dans les champs vides (3ᵉ ligne parasite) : coupé ici */
      html = html.replace('(function fill(t){', '(function fill(t){return;');
      var ifr = document.createElement('iframe');
      ifr.title = f(T.visio); ifr.setAttribute('tabindex', '-1'); ifr.setAttribute('aria-hidden', 'true');
      sceneIn.insertBefore(ifr, attente.nextSibling);
      /* filet : jamais 760 px ou plus au chargement (télémétrie de bureau et gabarits du moteur) */
      if (sceneIn.clientWidth >= 760){ ifr.style.width = '740px'; ifr.style.left = '50%'; ifr.style.marginLeft = '-370px'; }
      S.ifr = ifr;
      ifr.srcdoc = html;
      attendreMoteur();
    })['catch'](function(){ apercuKo(); });
  }
  function attendreMoteur(){
    var w = iWin(), d = iDoc();
    if (w && w.MT_CONFIG_I18N) brancherFin(w);
    var root = d && d.getElementById('mtp');
    if (root && root.getAttribute('data-mtp-ready') === '1' && champ(d, 'prenom')){
      S.dprNatif = w.devicePixelRatio || 1;
      majApercu();
      return attendrePhoto(w, d);
    }
    if (Date.now() - S.apercuT0 < 40000) setTimeout(attendreMoteur, 250); else apercuKo();
  }
  function attendrePhoto(w, d){
    if (cadrer()){
      placerSilhouette();
      policesPretes(w, d).then(function(){
        majApercu();
        if (!d.getElementById('mtpHole')) sansTrou(); /* le moteur ne propose pas le trou : l'option disparaît */
        syncTrou(w, d);
        try { w.__MTA_REDESSINE__(); } catch(e) {}
        requestAnimationFrame(function(){ requestAnimationFrame(apercuPret); });
      });
      return;
    }
    if (Date.now() - S.apercuT0 < 40000) setTimeout(function(){ attendrePhoto(w, d); }, 100); else apercuKo();
  }
  function apercuPret(){
    clearTimeout(S.koT); fond.dataset.apercu = 'pret'; majLoupe();
    if (S.trou) montrerTrou();
  }
  function apercuKo(){ if (fond && fond.dataset.apercu !== 'pret'){ fond.dataset.apercu = 'ko'; majLoupe(); } }
  function sansTrou(){
    O.trouOk = false; S.trou = false; fond.classList.add('mtxr-sans-trou');
    opts.forEach(function(o){ o.r.checked = o.v === 0; }); majTout();
  }
  /* silhouette d'attente : à la place exacte de la future tomette */
  function placerSilhouette(){
    if (!sceneIn || !attHex) return;
    var Vw = sceneIn.clientWidth, Vh = sceneIn.clientHeight; if (!Vw || !Vh) return;
    var hw, hh, x, y;
    if (S.m && S.tw && S.ifr && !S.visio){
      var th = S.tw / R;
      hw = S.m.kx * S.tw; hh = S.m.ky * th; x = S.ifr.offsetLeft + S.L + S.m.x0 * S.tw; y = S.ifr.offsetTop + S.T + S.m.y0 * th;
    } else {
      hw = Math.min(.94 * Vw, .94 * Vh * HEXR); hh = hw / HEXR; x = (Vw - hw) / 2; y = (Vh - hh) * .44;
    }
    var s = attHex.style;
    s.left = Math.round(x) + 'px'; s.top = Math.round(y) + 'px'; s.width = Math.round(hw) + 'px'; s.height = Math.round(hh) + 'px';
    s.setProperty('--hw', Math.round(hw) + 'px');
  }
  /* anneau qui pulse sur le trou qu'on vient d'ajouter */
  function montrerTrou(){
    if (!S.trou || !fond || fond.dataset.apercu !== 'pret') return;
    requestAnimationFrame(function(){
      var d = iDoc(), h = d && d.querySelector('#mtpTile .mtp-hole-window'); if (!h) return;
      var r = h.getBoundingClientRect(), ri = S.ifr.getBoundingClientRect(), rs = sceneIn.getBoundingClientRect();
      /* jamais sur le prénom : le haut des accents est à 1,6 diamètre de trou sous son centre ; l'anneau finit
         (×1,3, ombre comprise) à 1,45 diamètre au plus, 36 px au plus (bureau) */
      var dm = Math.round(borne(2 * (1.45 * r.height / 1.3 - 1.5), 16, 36));
      repere.style.width = repere.style.height = dm + 'px'; repere.style.margin = (-dm / 2) + 'px 0 0 ' + (-dm / 2) + 'px';
      repere.style.left = Math.round(ri.left - rs.left + r.left + r.width / 2) + 'px';
      repere.style.top = Math.round(ri.top - rs.top + r.top + r.height / 2) + 'px';
      repere.classList.remove('mtxr-pulse', 'mtxr-fixe'); void repere.offsetWidth;
      if (reduit()){ repere.classList.add('mtxr-fixe'); setTimeout(function(){ repere.classList.remove('mtxr-fixe'); }, 1500); }
      else repere.classList.add('mtxr-pulse');
    });
  }

  /* ── roue ── */
  /* quartiers « 10 € » et cœurs ; arrêt sur le « 10 € » du haut : le prix est le même quelle que soit la case */
  function roueSVG(){
    var ns = 'http://www.w3.org/2000/svg', svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '-108 -108 216 216'); svg.setAttribute('class', 'mtxr-roue'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    /* bordures terracotta et crème dessinées dans le SVG (et non en ombres CSS) : aucun filet sombre entre les anneaux */
    [[108, '#C1643C'], [104.5, '#F6EFE8']].forEach(function(c){ var o = document.createElementNS(ns, 'circle'); o.setAttribute('r', c[0]); o.setAttribute('fill', c[1]); svg.appendChild(o); });
    for (var i = 0; i < 8; i++){
      var prix = i % 2 === 0;
      var a0 = (i * 45 - 22.5 - 90) * Math.PI / 180, a1 = ((i + 1) * 45 - 22.5 - 90) * Math.PI / 180;
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', 'M0,0 L' + (100 * Math.cos(a0)).toFixed(2) + ',' + (100 * Math.sin(a0)).toFixed(2) + ' A100,100 0 0,1 ' + (100 * Math.cos(a1)).toFixed(2) + ',' + (100 * Math.sin(a1)).toFixed(2) + ' Z');
      p.setAttribute('fill', prix ? '#C1643C' : '#F6EFE8'); svg.appendChild(p);
      var t = document.createElementNS(ns, 'text');
      t.setAttribute('text-anchor', 'middle'); t.setAttribute('dominant-baseline', 'central');
      t.setAttribute('class', prix ? 'mtxr-r-prix' : 'mtxr-r-coeur'); t.setAttribute('fill', prix ? '#fff' : '#C1643C');
      t.setAttribute('transform', 'rotate(' + (i * 45) + ') translate(0,-64)');
      t.textContent = prix ? O.prix : '♥'; svg.appendChild(t);
    }
    return svg;
  }
  function confettis(zone){
    if (reduit()) return;
    var z = el('div', 'mtxr-confetti'), cols = ['#E39A74', '#F6EFE8', '#C1643C', '#e9c46a', '#fff'];
    for (var i = 0; i < 34; i++){ var c = el('i'); c.style.left = (Math.random() * 100) + '%'; c.style.background = cols[i % cols.length]; c.style.animationDelay = (Math.random() * .5) + 's'; z.appendChild(c); }
    zone.appendChild(z); setTimeout(function(){ if (z.parentNode) z.parentNode.removeChild(z); }, 2600);
  }

  /* ── panier ── */
  function lirePanier(){ return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function(r){ if (!r.ok) throw 0; return r.json(); }); }
  function ligneOffre(cart){ return ((cart && cart.items) || []).filter(function(i){ return i.product_id === O.productId; })[0]; }
  function aLOffre(cart){ return !!ligneOffre(cart); }
  /* le moteur, chargé dans l'aperçu (srcdoc), écrit un lien « Modifier » relatif à « srcdoc » : on le remet sur la fiche d'offre */
  function reparer(cart){
    var l = ligneOffre(cart);
    var p = l && l.properties || {}, m = String(p._modifier || '');
    if (!l || !m || m.charAt(0) === '/') return Promise.resolve(false);
    var np = {}; Object.keys(p).forEach(function(k){ np[k] = p[k]; });
    np._modifier = O.url + (m.indexOf('#') >= 0 ? m.slice(m.indexOf('#')) : '');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: l.key, quantity: l.quantity, properties: np }) })
      .then(function(r){ return r.ok; })['catch'](function(){ return false; });
  }

  /* ── ajout au panier : moteur d'abord, secours ensuite, jamais deux lignes d'offre ── */
  function btTexte(s){ if (btAjoutTxt) btAjoutTxt.textContent = s || ''; }
  function msg(s){ if (msgEl) msgEl.textContent = s || ''; }
  function attendrePret(ms){
    return new Promise(function(res){
      var t0 = Date.now();
      (function voir(){
        var a = fond.dataset.apercu;
        if (a === 'pret') return res(true);
        if (a === 'ko' || Date.now() - t0 > ms) return res(false);
        setTimeout(voir, 150);
      })();
    });
  }
  function ajouter(){
    if (S.ajout || S.etat !== 'gagne' || Date.now() < S.revelT + 600) return;
    S.ajout = true; S.t = tarif(); msg(''); poserEtat('ajout');
    btTexte(fond.dataset.apercu === 'pret' ? T.ajoutEnCours : T.ajoutAttente);
    /* dès qu'un essai (moteur ou secours) a déjà eu lieu, on regarde le panier d'abord */
    ((S.essais || S.secoursFait) ? lirePanier() : Promise.resolve(null)).then(function(cart){
      if (cart && ligneOffre(cart)) return finir(cart);
      if (fond.dataset.apercu === 'ko' || !S.ifr) return secours();
      return attendrePret(10000).then(function(ok){ if (ok){ btTexte(T.ajoutEnCours); return essaiMoteur(); } return secours(); });
    })['catch'](function(){ erreur(); });
  }
  function essaiMoteur(){
    var t = S.t, w = iWin(), d = iDoc(), b, load, vs = [], conforme = false;
    try {
      b = d.getElementById('mtpAdd'); load = d.getElementById('mtpLoad');
      try { vs = JSON.parse(d.getElementById('mtpData').textContent).variants || []; } catch(e) {}
      var cle = t.trou ? 'hexa|1' : 'hexa|0';
      conforme = !!b && !!load && S.essais < 2 && !!t.vid
        && vs.some(function(v){ return v && v.k === cle && String(v.id) === String(t.vid); })
        && syncTrou(w, d)
        && Math.round((w.__MTA_TARIF__ ? Number(w.__MTA_TARIF__('hexa', t.trou)) : 0) * 100) === t.barre;
    } catch(e) { conforme = false; }
    if (!conforme) return secours();
    S.essais++; S.finOk = false; brancherFin(w); suivre(d);
    majApercu();
    var to = d.getElementById('mtpToast'); if (to) to.textContent = '';
    try { b.click(); } catch(e) { couperSuivi(); return secours(); }   /* addToCart est synchrone jusqu'à l'affichage du chargement */
    if (!load.classList.contains('mtp-on')) return echecMoteur(lireToast(d), false); /* refusé avant tout envoi */
    S.filetT = setTimeout(filet, 25000);
  }
  function suivre(d){
    couperSuivi();
    var load = d.getElementById('mtpLoad'), cap = d.getElementById('mtpLoadCap');
    S.obs = [ new MutationObserver(function(){
        if (load.classList.contains('mtp-on')) return;
        setTimeout(function(){ if (!S.finOk && S.ajout && S.obs) echecMoteur(lireToast(d), true); }, 0); /* chargement fermé sans « /cart » = échec */
      }), new MutationObserver(function(){ if (S.ajout && !S.finOk && cap && cap.textContent) btTexte(cap.textContent); }) ];
    S.obs[0].observe(load, { attributes: true, attributeFilter: ['class'] });
    if (cap) S.obs[1].observe(cap, { childList: true, characterData: true, subtree: true });
  }
  function couperSuivi(){ (S.obs || []).forEach(function(o){ try { o.disconnect(); } catch(e) {} }); S.obs = null; clearTimeout(S.filetT); }
  function lireToast(d){ var e = d && d.getElementById('mtpToast'); return e ? String(e.textContent || '').trim() : ''; }
  function finMoteur(){
    couperSuivi(); var n = 0;
    (function voir(){
      lirePanier().then(function(cart){
        if (ligneOffre(cart)) return finir(cart);
        if (++n < 4) return setTimeout(voir, 1000); erreur();
      })['catch'](function(){ if (++n < 4) setTimeout(voir, 1000); else erreur(); });
    })();
  }
  function echecMoteur(txt, envoye){
    couperSuivi();
    (envoye ? lirePanier() : Promise.resolve(null)).then(function(cart){
      if (cart && ligneOffre(cart)) return finir(cart);          /* le moteur a abandonné mais Shopify a bien ajouté */
      if (S.essais >= 2) return secours();
      if (!envoye) return setTimeout(essaiMoteur, 1000);         /* par ex. boutique pas encore reconnue : un second essai */
      erreur(txt);                                               /* 1er échec après envoi : le client relance */
    })['catch'](function(){ erreur(txt); });
  }
  function filet(){ /* aucun signal à 25 s : on regarde le panier toutes les 3 s jusqu'à 75 s */
    var t0 = Date.now();
    (function voir(){
      if (!S.ajout || S.finOk) return;
      lirePanier().then(function(cart){
        if (ligneOffre(cart)){ couperSuivi(); return finir(cart); }
        if (Date.now() - t0 < 50000 && S.ajout && !S.finOk) setTimeout(voir, 3000); else if (S.ajout && !S.finOk){ couperSuivi(); erreur(); }
      })['catch'](function(){ if (Date.now() - t0 < 50000) setTimeout(voir, 3000); });
    })();
  }
  function finir(cart){ return reparer(cart).then(reussi, reussi); }
  function reussi(){
    if (S.etat === 'ok') return;
    couperSuivi(); poserEtat('ok'); btTexte('✓ ' + (T.ajoutee || ''));
    setTimeout(function(){ depiler(S.hist, function(){ location.reload(); }); }, 600);
  }
  function erreur(txt){ couperSuivi(); S.ajout = false; poserEtat('gagne'); msg(txt || T.erreur || ''); majCta(); }
  /* secours : ajout direct avec le texte — l'atelier regrave depuis le prénom et la phrase. Même variante que choisie. */
  function secours(){
    var t = S.t; if (!t || !t.vid) return erreur();             /* jamais une « Pleine » si le client a choisi « Percée » */
    S.secoursFait = true; couperSuivi();
    return lirePanier().then(function(cart){
      if (ligneOffre(cart)) return finir(cart);
      var l = decouper(S.nom.p[S.phrase] || ''), props = { 'Prénom': S.nom.n.toUpperCase(), 'Phrase, ligne 1': (l[0] || '').toUpperCase() };
      if (l[1]) props['Phrase, ligne 2'] = l[1].toUpperCase();
      if (l[2]) props['Phrase, ligne 3'] = l[2].toUpperCase();
      props['Forme'] = 'Hexagonale' + (t.trou ? ' (percée)' : '');   /* mêmes libellés que le moteur */
      if (t.trou) props['Trou de suspension'] = 'Oui';
      props._source = 'roulette';
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: t.vid, quantity: 1, properties: props }] }) })
        .then(function(r){
          if (r.ok) return reussi();
          return r.json().then(function(j){ erreur(j && (j.description || j.message)); }, function(){ erreur(); });
        });
    })['catch'](function(){ erreur(); });
  }

  /* ── bulle ── */
  var fond, boite, btX, defile, scene, sceneIn, attente, attHex, attNom, attPhrase, attTxt, repere, btOuvrir, loupe,
      geste, vX, vBarre, vMoins, vAjuster, vPlus, vAide, col, tete, nomsBox, pourEl, titre, ctrl, jeu, roue, titreM, tJeuL,
      tGagne, prixBox, prixN, prixB, badge, badgeR, supEl, phTxt, phLib, phLibC, pied, btTourner, btAjout, btAjoutTxt, msgEl, btNon,
      desc, annonce, rappel, dock;
  var opts = [], nomsR = [], phBts = [];
  var ICO_LOUPE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.6v5.8M7.6 10.5h5.8"/></svg>';
  /* tomette hexagonale (haut plat, 12 × 10 cm) ; percée : le trou est un sous-tracé évidé (fill-rule evenodd) */
  var HEX_D = 'M6 1.2h12L22.8 10 18 18.8H6L1.2 10z';
  var ICO_PLEINE = '<svg class="mtxr-ico" viewBox="0 0 24 20" width="22" height="18" aria-hidden="true" focusable="false"><path d="' + HEX_D + '"/></svg>';
  var ICO_PERCEE = '<svg class="mtxr-ico" viewBox="0 0 24 20" width="22" height="18" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="' + HEX_D + 'M10.1 4.9a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0-3.8 0z"/></svg>';

  function annoncer(txt){ if (!annonce) return; annonce.textContent = ''; setTimeout(function(){ annonce.textContent = txt || ''; }, 40); }
  /* « 2ᵉ » : la lettre en exposant est écrite en vraie balise, dans la police du texte (Instrument Serif n'a pas ᵉ) */
  function ord(h, s){
    String(s || '').split('ᵉ').forEach(function(p, i){ if (i) h.appendChild(el('sup', 'mtxr-ord', 'e')); if (p) h.appendChild(document.createTextNode(p)); });
  }
  function remplirTitre(h){
    h.textContent = ''; ord(h, (T.titreA || '') + ' ');
    h.appendChild(el('em', null, S.nom.n)); ord(h, ' ' + (T.titreB || ''));
  }
  function radio(name, v, on){ var r = document.createElement('input'); r.type = 'radio'; r.name = name; r.value = String(v); r.checked = !!on; r.className = 'mtxr-radio'; return r; }

  function construire(){
    if (fond) return;
    fond = el('div', 'mtxr-fond mtxr-cache');
    fond.setAttribute('role', 'dialog'); fond.setAttribute('aria-modal', 'true'); fond.setAttribute('aria-label', T.aria || '');
    fond.dataset.etat = 'jeu'; fond.dataset.apercu = 'attente'; fond.dataset.trou = '0'; fond.dataset.visio = '0'; fond.dataset.zoom = '0';
    boite = el('div', 'mtxr-boite'); boite.tabIndex = -1; fond.appendChild(boite);
    btX = bouton('mtxr-x', '×', T.fermer || 'Fermer'); btX.addEventListener('click', function(){ fermer(); }); boite.appendChild(btX);
    defile = el('div', 'mtxr-defile'); boite.appendChild(defile);
    /* jamais de défilement horizontal (un focus peut en provoquer un malgré overflow-x:hidden) */
    defile.addEventListener('scroll', function(){ if (defile.scrollLeft) defile.scrollLeft = 0; }, { passive: true });

    /* scène : la tomette, grande, à la même place dans tous les états */
    scene = el('div', 'mtxr-scene'); sceneIn = el('div', 'mtxr-scene-in'); scene.appendChild(sceneIn); defile.appendChild(scene);
    attente = el('div', 'mtxr-attente'); attHex = el('div', 'mtxr-att-hex');
    attNom = el('b', 'mtxr-att-nom'); attPhrase = el('span', 'mtxr-att-phrase'); attTxt = el('p', 'mtxr-att-txt');
    attHex.appendChild(attNom); attHex.appendChild(el('span', 'mtxr-att-coeur', '♥')); attHex.appendChild(attPhrase); attHex.appendChild(attTxt);
    attente.appendChild(attHex); sceneIn.appendChild(attente);
    repere = el('span', 'mtxr-repere'); repere.setAttribute('aria-hidden', 'true'); sceneIn.appendChild(repere);
    btOuvrir = bouton('mtxr-ouvrir'); btOuvrir.setAttribute('aria-describedby', 'mtxrDesc'); btOuvrir.disabled = true; sceneIn.appendChild(btOuvrir);
    loupe = el('span', 'mtxr-loupe'); loupe.setAttribute('aria-hidden', 'true'); loupe.innerHTML = ICO_LOUPE; loupe.appendChild(el('span', 'mtxr-loupe-t', T.agrandir || '')); sceneIn.appendChild(loupe);
    var taille = el('span', 'mtxr-taille'); taille.setAttribute('aria-hidden', 'true');
    taille.appendChild(el('span', 'mtxr-taille-c', T.taille || '')); taille.appendChild(el('span', 'mtxr-taille-l', T.tailleLong || '')); sceneIn.appendChild(taille);
    /* vue agrandie */
    geste = el('div', 'mtxr-geste'); geste.tabIndex = 0; geste.setAttribute('role', 'group'); geste.setAttribute('aria-label', T.visioGeste || ''); geste.hidden = true; sceneIn.appendChild(geste);
    vX = bouton('mtxr-v-x', '×', T.visioFermer); vX.hidden = true; sceneIn.appendChild(vX);
    vBarre = el('div', 'mtxr-v-barre'); vBarre.hidden = true;
    vMoins = bouton('mtxr-v-moins', '−', T.zoomMoins); vAjuster = bouton('mtxr-v-ajuster', T.zoomAjuster); vPlus = bouton('mtxr-v-plus', '+', T.zoomPlus);
    vBarre.appendChild(vMoins); vBarre.appendChild(vAjuster); vBarre.appendChild(vPlus); sceneIn.appendChild(vBarre);
    vAide = el('p', 'mtxr-v-aide'); vAide.setAttribute('aria-hidden', 'true'); vAide.hidden = true; sceneIn.appendChild(vAide);

    /* colonne : prénom, roue puis offre, bouton */
    col = el('div', 'mtxr-col'); defile.appendChild(col);
    tete = el('div', 'mtxr-tete'); col.appendChild(tete);
    tete.appendChild(el('p', 'mtxr-kicker', T.kicker || ''));
    if (S.noms.length > 1){
      nomsBox = el('div', 'mtxr-noms'); nomsBox.setAttribute('role', 'radiogroup'); nomsBox.setAttribute('aria-labelledby', 'mtxrPour');
      pourEl = el('span', 'mtxr-pour', T.pour || ''); pourEl.id = 'mtxrPour'; nomsBox.appendChild(pourEl);
      S.noms.forEach(function(nm, i){
        var lb = el('label', 'mtxr-nom' + (i === 0 ? ' mtxr-sel' : '')), r = radio('mtxrNom', i, i === 0);
        r.addEventListener('change', function(){ if (r.checked) choisirNom(i); });
        lb.appendChild(r); lb.appendChild(el('span', null, nm.n)); nomsBox.appendChild(lb); nomsR.push({ lb: lb, r: r });
      });
      tete.appendChild(nomsBox);
    }
    titre = el('h2', 'mtxr-titre'); col.appendChild(titre);
    ctrl = el('div', 'mtxr-ctrl'); col.appendChild(ctrl);
    /* jeu */
    jeu = el('div', 'mtxr-jeu');
    var rz = el('div', 'mtxr-roue-z'); rz.appendChild(el('div', 'mtxr-pointe')); roue = roueSVG(); rz.appendChild(roue); rz.appendChild(el('div', 'mtxr-moyeu', '★'));
    var jt = el('div', 'mtxr-jeu-txt');
    jt.appendChild(el('p', 'mtxr-kicker-m', T.kicker || '')); titreM = el('h2', 'mtxr-titre-m'); jt.appendChild(titreM);
    tJeuL = el('p', 'mtxr-t-jeu mtxr-t-jeu-l'); jt.appendChild(tJeuL); jt.appendChild(el('p', 'mtxr-t-jeu mtxr-t-jeu-c', T.jeuCourt || ''));
    jeu.appendChild(rz); jeu.appendChild(jt); ctrl.appendChild(jeu);
    /* offre révélée */
    var off = el('div', 'mtxr-offre');
    tGagne = el('p', 'mtxr-t-gagne'); off.appendChild(tGagne);
    prixBox = el('div', 'mtxr-prix'); prixBox.tabIndex = -1;
    /* prix, prix barré, une seule pastille « Gagné ! −8,90 € » (le « Gagné ! » s'efface là où la phrase d'annonce le dit déjà) */
    prixN = el('b', 'mtxr-prix-n'); prixB = el('s', 'mtxr-prix-b'); badge = el('span', 'mtxr-badge');
    badge.appendChild(el('span', 'mtxr-badge-g', T.gagneCourt || '')); badgeR = el('span', 'mtxr-badge-r'); badge.appendChild(badgeR);
    prixBox.appendChild(prixN); prixBox.appendChild(el('span', 'mtxr-sr', ' ' + (T.auLieuDe || '') + ' ')); prixBox.appendChild(prixB); prixBox.appendChild(badge);
    off.appendChild(prixBox);
    if (O.trouOk){
      var leg = el('p', 'mtxr-trou-leg', T.trouLegende || ''); leg.id = 'mtxrTrouLeg'; off.appendChild(leg);
      var tb = el('div', 'mtxr-trou'); tb.setAttribute('role', 'radiogroup'); tb.setAttribute('aria-labelledby', 'mtxrTrouLeg');
      [[0, T.trouNon, T.trouNonSous], [1, T.trouOui, T.trouOuiSous]].forEach(function(d){
        var lb = el('label', 'mtxr-opt' + (d[0] === 0 ? ' mtxr-sel' : '')), r = radio('mtxrTrou', d[0], d[0] === 0);
        r.addEventListener('change', function(){ if (r.checked) choisirTrou(d[0] === 1); });
        var pp = el('span', 'mtxr-opt-p'); if (d[0]) supEl = pp;
        /* l'indicateur est une petite tomette (pleine quand la carte est choisie), percée pour « Avec trou » */
        var ic = el('span', 'mtxr-rond'); ic.innerHTML = d[0] ? ICO_PERCEE : ICO_PLEINE;
        lb.appendChild(r); lb.appendChild(ic); lb.appendChild(el('span', 'mtxr-opt-t', d[1] || '')); lb.appendChild(pp); lb.appendChild(el('small', 'mtxr-opt-s', d[2] || ''));
        tb.appendChild(lb); opts.push({ lb: lb, r: r, v: d[0] });
      });
      off.appendChild(tb);
    } else fond.classList.add('mtxr-sans-trou');
    var ph = el('div', 'mtxr-phrase'), pt = el('div', 'mtxr-ph-tete'), nav = el('div', 'mtxr-ph-nav'), navC = el('div', 'mtxr-ph-c');
    phLib = el('small', 'mtxr-ph-lib'); pt.appendChild(phLib);
    function flecheP(dir, cls){ var b = bouton('mtxr-ph-bt ' + cls, dir < 0 ? '‹' : '›', dir < 0 ? T.phrasePrec : T.phraseSuiv); b.addEventListener('click', function(){ changerPhrase(dir); }); phBts.push(b); return b; }
    nav.appendChild(flecheP(-1, 'mtxr-ph-p')); nav.appendChild(flecheP(1, 'mtxr-ph-s')); pt.appendChild(nav); ph.appendChild(pt);
    phTxt = el('span', 'mtxr-ph-txt'); ph.appendChild(phTxt);
    navC.appendChild(flecheP(-1, 'mtxr-ph-p')); phLibC = el('span', 'mtxr-ph-c-lib'); navC.appendChild(phLibC); navC.appendChild(flecheP(1, 'mtxr-ph-s')); ph.appendChild(navC);
    off.appendChild(ph);
    ctrl.appendChild(off);
    /* pied collant */
    pied = el('div', 'mtxr-pied');
    btTourner = bouton('mtxr-bt mtxr-bt-tourner', T.tourner || ''); btTourner.addEventListener('click', tourner); pied.appendChild(btTourner);
    btAjout = bouton('mtxr-bt mtxr-bt-ajout'); btAjout.appendChild(el('span', 'mtxr-spin')); btAjoutTxt = el('span', 'mtxr-bt-t'); btAjout.appendChild(btAjoutTxt);
    btAjout.addEventListener('click', ajouter); pied.appendChild(btAjout);
    msgEl = el('p', 'mtxr-msg'); msgEl.setAttribute('role', 'alert'); pied.appendChild(msgEl);
    col.appendChild(pied);
    var fin = el('div', 'mtxr-fin'), cond = el('p', 'mtxr-cond'); ord(cond, T.conditions); fin.appendChild(cond);
    btNon = bouton('mtxr-non', T.non || ''); btNon.addEventListener('click', function(){ fermer(); }); fin.appendChild(btNon); col.appendChild(fin);
    desc = el('p', 'mtxr-sr'); desc.id = 'mtxrDesc'; boite.appendChild(desc);
    annonce = el('p', 'mtxr-sr mtxr-annonce'); annonce.setAttribute('aria-live', 'polite'); boite.appendChild(annonce);

    /* fermeture par le fond : seulement si l'appui ET le clic ont eu lieu sur le fond */
    fond.addEventListener('pointerdown', function(e){ S.basFond = e.target === fond; });
    fond.addEventListener('click', function(e){ if (e.target === fond && S.basFond) fermer(); });
    brancherVisio();

    document.body.appendChild(fond);
    poserMise(); majTout(); placerSilhouette();
    if (window.ResizeObserver){
      new ResizeObserver(function(){ if (cadrer()) majRepere(); placerSilhouette(); }).observe(sceneIn);
    }
    preparerApercu();
  }

  /* ── mises en page ── */
  function poserMise(){
    if (!fond) return;
    var W = window.innerWidth, H = window.innerHeight, m, h;
    m = (W >= 1024 || (W >= 760 && H < 700) || (W >= 480 && H <= 500 && W > H)) ? 'colonnes' : (W >= 760 ? 'carte' : 'feuille');
    h = m === 'colonnes' ? (H <= 520 ? 'bas' : (H < 744 ? 'moyen' : 'haut')) : (H >= 760 ? 'haut' : (H >= 600 ? 'moyen' : 'bas'));
    fond.dataset.mise = m; fond.dataset.hauteur = h;
    /* colonne de droite : 420 px sur bureau (340 au moins ailleurs) ; quand la tomette est limitée par la hauteur,
       la place inutile à gauche lui revient (téléphone à l'horizontale) */
    var pad = (m === 'colonnes' && h === 'bas') ? 8 : 32, marge = h === 'bas' ? 12 : 24;
    var bw = Math.min(1160, W - 2 * pad), bh = Math.min(720, H - 2 * pad), gauche = (bh - 2 * marge) * 1.12 + 2 * marge;
    fond.style.setProperty('--mtxr-droite', Math.round(Math.max(W >= 1024 ? 420 : 340, Math.min(440, bw - gauche))) + 'px');
    fond.classList.toggle('mtxr-multi', S.noms.length > 1);
    fond.classList.toggle('mtxr-phrase-courte', h === 'bas' || (h === 'moyen' && m !== 'colonnes' && S.noms.length > 1));
    if (pourEl) pourEl.textContent = m === 'feuille' ? (T.pour || '') : (T.pourQui || '');
    if (nomsBox) nomsBox.classList.toggle('mtxr-deborde', nomsBox.scrollWidth > nomsBox.clientWidth + 1);
    majCta();
  }
  var miseR = 0;
  function miseBientot(){ if (miseR || !fond) return; miseR = requestAnimationFrame(function(){ miseR = 0; poserMise(); }); }
  window.addEventListener('resize', miseBientot);
  window.addEventListener('orientationchange', miseBientot);

  /* ── mise à jour des textes, du prix et de l'aperçu ── */
  function majCta(){
    if (!btAjout || S.ajout || S.etat === 'ok' || !S.nom) return;
    var n = S.nom.n.toUpperCase();
    btAjout.classList.remove('mtxr-2l'); btTexte(f(T.cta, { n: n }));
    var cs = getComputedStyle(btAjout), dispo = btAjout.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    if (dispo > 0 && btAjoutTxt.offsetWidth > dispo){
      btTexte(f(T.ctaCourt, { n: n }));
      if (btAjoutTxt.offsetWidth > dispo) btAjout.classList.add('mtxr-2l');
    }
  }
  function majTout(){
    if (!fond || !S.nom) return;
    var t = tarif(), nb = (S.nom.p || []).length;
    prixN.textContent = t.prix; prixB.textContent = t.prixBarre; badgeR.textContent = t.remise;
    if (supEl) supEl.textContent = t.sup;
    majCta();
    remplirTitre(titre); remplirTitre(titreM);
    tJeuL.textContent = f(T.jeu); tGagne.textContent = f(T.gagne);
    phLib.textContent = f(T.phraseTete); phLibC.textContent = f(T.phraseNav); phTxt.textContent = S.nom.p[S.phrase] || '';
    fond.classList.toggle('mtxr-une-phrase', nb <= 1); fond.classList.toggle('mtxr-sans-phrase', !nb);
    desc.textContent = f(T.apercuDesc) + (t.trou ? (T.apercuDescTrou || '') : '');
    btOuvrir.setAttribute('aria-label', f(T.agrandirAria));
    attNom.textContent = S.nom.n; attPhrase.textContent = decouper(S.nom.p[S.phrase] || '').join('\n'); attTxt.textContent = f(T.chargement);
    fond.dataset.trou = t.trou ? '1' : '0';
    opts.forEach(function(o){ o.lb.classList.toggle('mtxr-sel', o.r.checked); });
    nomsR.forEach(function(o){ o.lb.classList.toggle('mtxr-sel', o.r.checked); });
    majApercu();
    if (fond.dataset.apercu === 'pret') syncTrou();
  }
  /* la tomette d'abord : si le contenu a défilé (Tab vers « Non merci », lecture des conditions), on remonte ;
     renvoie le temps à attendre avant de montrer quelque chose sur la tomette */
  function remonter(){
    if (!defile || defile.scrollTop <= 0) return 0;
    var lisse = !reduit();
    try { defile.scrollTo({ top: 0, behavior: lisse ? 'smooth' : 'auto' }); } catch(e) { defile.scrollTop = 0; }
    return lisse ? 320 : 0;
  }
  function choisirNom(i){
    if (!S.noms[i] || S.nom === S.noms[i]) return;
    S.nom = S.noms[i]; S.phrase = 0; majTout(); annoncer(f(T.annonceNom)); remonter();
  }
  function changerPhrase(dir){
    var n = (S.nom.p || []).length || 1; if (n < 2) return;
    S.phrase = (S.phrase + dir + n) % n; majTout(); annoncer(f(T.annoncePhrase));
  }
  function choisirTrou(v){
    v = !!v && O.trouOk; if (S.trou === v) return;
    S.trou = v;
    prixN.classList.add('mtxr-flash'); setTimeout(function(){ prixN.classList.remove('mtxr-flash'); }, 150);
    majTout(); annoncer(f(v ? T.annonceTrouOui : T.annonceTrouNon));
    var dt = remonter();
    if (v){ clearTimeout(S.trouT); if (dt) S.trouT = setTimeout(montrerTrou, dt); else montrerTrou(); }
  }
  function poserEtat(e){
    S.etat = e; if (!fond) return;
    fond.dataset.etat = e;
    var revele = e === 'gagne' || e === 'ajout' || e === 'ok', occupe = e === 'ajout' || e === 'ok';
    fond.classList.toggle('mtxr-revele', revele);
    btTourner.disabled = e !== 'jeu';
    btAjout.disabled = occupe;
    nomsR.forEach(function(o){ o.r.disabled = e === 'rotation' || occupe; });
    opts.forEach(function(o){ o.r.disabled = occupe; });
    phBts.forEach(function(b){ b.disabled = occupe; });
    btNon.disabled = occupe;
    if (occupe) sceneIn.setAttribute('aria-busy', 'true'); else sceneIn.removeAttribute('aria-busy');
    majLoupe();
  }
  function majLoupe(){
    if (!fond) return;
    var ok = fond.dataset.apercu === 'pret' && !S.ajout && S.etat !== 'ok';
    fond.dataset.zoom = ok ? '1' : '0';
    if (btOuvrir.disabled === ok){ if (!ok && document.activeElement === btOuvrir) try { btAjout.focus({ preventScroll: true }); } catch(e) {} btOuvrir.disabled = !ok; }
  }
  function majRepere(){ /* l'anneau suit la tomette si la scène change de taille pendant qu'il pulse */
    if (repere && (repere.classList.contains('mtxr-pulse') || repere.classList.contains('mtxr-fixe'))) montrerTrou();
  }

  /* ── roue ── */
  function tourner(){
    if (S.etat !== 'jeu') return;
    /* le bouton va être désactivé : le focus passe d'abord sur la boîte (sinon il tombe hors de la bulle pendant la rotation) */
    if (document.activeElement === btTourner) try { boite.focus({ preventScroll: true }); } catch(e) {}
    poserEtat('rotation'); annoncer(T.rotation);
    if (reduit()){ gagner(); return; }
    var angle = 360 * 5 + (Math.random() * 20 - 10); /* toutes les cases gagnent */
    roue.style.transform = 'rotate(' + angle + 'deg)';
    setTimeout(function(){ jeu.classList.add('mtxr-sort'); setTimeout(gagner, 150); }, 3600);
  }
  function gagner(){
    if (S.etat !== 'rotation') return;
    poserEtat('gagne'); S.revelT = Date.now();
    majTout(); confettis(col);
    try { prixBox.focus({ preventScroll: true }); } catch(e) {}
    annoncer(f(T.annoncePrix));
    var dt = remonter();
    if (S.trou) setTimeout(montrerTrou, dt);
  }

  /* ── ouverture, fermeture, clavier ── */
  function focusables(){
    var root = S.visio ? sceneIn : boite;
    return Array.prototype.filter.call(root.querySelectorAll('button, input, [tabindex]'), function(e){
      if (e.disabled || e.tabIndex < 0 || e.closest('[inert],[hidden]')) return false;
      if (e.type === 'radio' && !e.checked) return false;
      return e.getClientRects().length > 0 && getComputedStyle(e).visibility !== 'hidden';
    });
  }
  function cycle(dir){
    var l = focusables(); if (!l.length) return;
    var i = l.indexOf(document.activeElement);
    var n = i < 0 ? (dir > 0 ? l[0] : l[l.length - 1]) : l[(i + dir + l.length) % l.length];
    try { n.focus(); } catch(e) {}
  }
  function clavier(e){
    if (!S.ouvert) return;
    /* la bulle est modale : Tab et Échap ne vont pas aux autres pièges à focus de la page (bannière cookies…) */
    if (e.key === 'Escape' || e.key === 'Esc'){ e.preventDefault(); e.stopImmediatePropagation(); if (S.visio) fermerVisio(); else fermer(); return; }
    if (e.key === 'Tab'){ e.preventDefault(); e.stopImmediatePropagation(); cycle(e.shiftKey ? -1 : 1); return; }
    if (S.visio) clavierVisio(e);
  }
  /* le focus ne sort pas de la bulle ouverte (un autre script de la page peut s'en emparer) et n'entre jamais dans l'aperçu */
  function garderFocus(e){
    if (!S.ouvert || !fond) return;
    var t = e.target;
    if (t && t !== S.ifr && fond.contains(t)) return;
    var l = focusables(); if (l.length) try { l[0].focus({ preventScroll: true }); } catch(x) {}
  }
  function inerte(l, on){ l.forEach(function(e){ if (!e) return; try { e.inert = on; } catch(x) {} if (on) e.setAttribute('inert', ''); else e.removeAttribute('inert'); }); }
  /* ── bouton « retour » du navigateur : une entrée d'historique par couche ouverte (bulle, vue agrandie) ;
     le retour referme la couche du dessus au lieu de quitter le panier. Fermer autrement retire l'entrée. ── */
  S.hist = 0; S.popIgnore = 0;
  function empiler(cle){ try { var st = { mtxr: cle }; history.pushState(st, ''); S.hist++; } catch(e) {} }
  function depiler(n, puis){
    n = Math.min(n || 0, S.hist);
    if (n <= 0){ if (puis) puis(); return; }
    S.hist -= n; S.popIgnore++; S.apresPop = puis || null;
    clearTimeout(S.popT);
    S.popT = setTimeout(function(){ if (!S.popIgnore) return; S.popIgnore = 0; var p = S.apresPop; S.apresPop = null; if (p) p(); }, 700);
    try { history.go(-n); } catch(e) { clearTimeout(S.popT); S.popIgnore = 0; S.apresPop = null; if (puis) puis(); }
  }
  window.addEventListener('popstate', function(e){
    if (S.popIgnore > 0){ S.popIgnore--; clearTimeout(S.popT); var p = S.apresPop; S.apresPop = null; if (p) p(); return; }
    if (!S.hist) return;
    var st = (e.state && e.state.mtxr) || '';
    if (S.visio && st !== 'visio'){ S.hist = Math.max(0, S.hist - 1); fermerVisio(false, true); }
    if (S.ouvert && st !== 'visio' && st !== 'bulle'){ S.hist = 0; fermer(true); }
  });
  function ouvrir(){
    if (!S.nom) return;
    construire();
    if (S.ouvert) return;
    if (S.popIgnore){ setTimeout(ouvrir, 150); return; } /* un retour d'historique est en cours */
    S.focusAvant = document.activeElement;
    fond.style.display = ''; fond.classList.remove('mtxr-cache');
    poserMise();
    defile.scrollTop = 0; col.scrollTop = 0; /* rouverte par la pastille : la tomette en haut, pas le défilement d'avant */
    S.ovf = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
    S.ouvert = true; S.ouvertT = Date.now();
    void fond.offsetWidth;
    requestAnimationFrame(function(){ fond.classList.add('mtxr-on'); setTimeout(majCta, 60); });
    setTimeout(function(){
      var b = S.etat === 'jeu' ? boite : (S.etat === 'rotation' ? null : prixBox); /* la boîte : Tab mène ensuite aux commandes */
      if (b) try { b.focus({ preventScroll: true }); } catch(e) {}
    }, 420);
    document.addEventListener('keydown', clavier, true);
    document.addEventListener('focusin', garderFocus, true);
    empiler('bulle');
  }
  function fermer(parHistoire){
    if (!fond || !S.ouvert) return;
    if (S.visio) fermerVisio(true, true);
    if (parHistoire !== true) depiler(S.hist);
    ecrireS(CLE, '1'); document.documentElement.style.overflow = S.ovf || '';
    S.ouvert = false; fond.classList.remove('mtxr-on');
    setTimeout(function(){ if (!S.ouvert) fond.style.display = 'none'; }, 350);
    document.removeEventListener('keydown', clavier, true);
    document.removeEventListener('focusin', garderFocus, true);
    montrerRappel();
    var a = S.focusAvant;
    if (a && a !== document.body && document.documentElement.contains(a)) try { a.focus({ preventScroll: true }); } catch(e) {}
  }
  function montrerRappel(){
    if (!rappel){
      rappel = el('button', 'mtxr-rappel'); rappel.type = 'button';
      rappel.addEventListener('click', function(){ rappel.classList.remove('mtxr-on'); placer(); ouvrir(); });
      document.body.appendChild(rappel);
    }
    var p = tarif().prix; /* le prix du choix en cours (13 € si « Avec trou » est choisi, et gardé à la réouverture) */
    rappel.innerHTML = ''; rappel.appendChild(document.createTextNode('🎁 ' + f(T.rappel, { p: p }) + ' ')); rappel.appendChild(el('b', null, p));
    rappel.classList.add('mtxr-on'); placer(); setTimeout(placer, 600);
  }

  /* ── vue agrandie : la tuile grandit dans l'iframe, le moteur la redessine nette ── */
  var P = {}, G = null, WH = null, GS = null, rafG = 0, fnG = null;
  function planifier(fn){ fnG = fn; if (rafG) return; rafG = requestAnimationFrame(function(){ rafG = 0; var f0 = fnG; fnG = null; if (f0) f0(); }); }
  function nbP(){ return Object.keys(P).length; }
  function ouvrirVisio(pt){
    if (S.visio || !S.ifr || fond.dataset.apercu !== 'pret' || S.ajout || S.etat === 'ok' || S.popIgnore || Date.now() < S.ouvertT + 450) return;
    /* un appui sur la pastille « Agrandir » vaut une ouverture sans point : centrée sur la tomette */
    var lr = pt && loupe.getBoundingClientRect(), surLoupe = !!(lr && lr.width && pt.x >= lr.left - 8 && pt.x <= lr.right + 8 && pt.y >= lr.top - 8 && pt.y <= lr.bottom + 8);
    var hx = (pt && !surLoupe && cadrer()) ? versHex(pt.x, pt.y) : null;
    S.lg = largeurLignes();
    S.visio = true; fond.dataset.visio = '1'; scene.classList.add('mtxr-plein');
    inerte([btX, col, btOuvrir], true);
    [geste, vX, vBarre, vAide].forEach(function(e){ e.hidden = false; });
    S.Z = { z: 1, cx: .5, cy: .5 }; cadrer();               /* force la mise en page : pas d'image avec l'ancienne tuile */
    /* la vue s'ouvre déjà agrandie : ×1,5 au doigt, ×1,8 à la souris et au clavier (ajustée, elle ne gagnait que 5 à 20 %
       sur un portable) ; sur le point touché ou cliqué, sinon au centre (prénom, cœur et phrase visibles ensemble) */
    var z0 = Math.min(TACTILE ? 1.5 : 1.8, S.zMax);
    if (z0 > 1.001 && (hx || surLoupe || !TACTILE)){ S.Z = { z: z0, cx: .5, cy: hx ? borne(hx.y, .2, .85) : .5 }; cadrer(); }
    try { iWin().__MTA_REDESSINE__(); } catch(e) {}
    majBoutonsZoom(); montrerAide();
    try { geste.focus({ preventScroll: true }); } catch(e) {}
    empiler('visio');
  }
  function fermerVisio(sansFocus, sansHistoire){
    if (!S.visio) return;
    if (!sansHistoire) depiler(1);
    var w = iWin(); S.ifr.style.transform = ''; S.ifr.style.transformOrigin = '';
    P = {}; G = null; GS = null; if (WH){ clearTimeout(WH.t); WH = null; }
    S.visio = false; rendreDpr(w);
    scene.classList.remove('mtxr-plein'); fond.dataset.visio = '0'; fond.classList.remove('mtxr-glisse');
    inerte([btX, col, btOuvrir], false); [geste, vX, vBarre, vAide].forEach(function(e){ e.hidden = true; });
    S.Z = { z: 1, cx: .5, cy: .5 }; cadrer(); placerSilhouette();
    try { w.__MTA_REDESSINE__(); } catch(e) {}
    if (!sansFocus) try { btOuvrir.focus({ preventScroll: true }); } catch(e) {}
  }
  function apercuGeste(k, o, dx, dy){ /* retour immédiat sur l'élément iframe, jamais sur la tuile : le moteur ne voit rien */
    S.ifr.style.transformOrigin = o.x + 'px ' + o.y + 'px';
    S.ifr.style.transform = 'translate(' + (dx || 0) + 'px,' + (dy || 0) + 'px) scale(' + k + ')';
  }
  function valider(k, p, hx){
    S.ifr.style.transform = ''; S.ifr.style.transformOrigin = '';
    if (!S.m || !S.tw0) return;
    var z = borne(S.Z.z * k, 1, S.zMax), tw = S.tw0 * z;
    if (hx) S.Z = { z: z, cx: hx.x + (S.ifr.clientWidth / 2 - p.x) / (S.m.kx * tw), cy: hx.y + (S.ifr.clientHeight / 2 - p.y) / (S.m.ky * tw / R) };
    else S.Z.z = z;
    cadrer(); majBoutonsZoom();
  }
  function centre(){ return { x: S.ifr.clientWidth / 2, y: S.ifr.clientHeight / 2 }; }
  function zoomPar(k, p){ if (!S.visio || !S.m) return; p = p || centre(); valider(k, p, versHex(p.x, p.y)); }
  function ajuster(){ if (!S.visio) return; S.Z = { z: 1, cx: .5, cy: .5 }; cadrer(); majBoutonsZoom(); }
  function basculerZoom(p){ if (S.Z.z < 1.9) zoomPar(Math.min(2.2, S.zMax) / S.Z.z, p); else ajuster(); }
  function deplacer(dx, dy){
    if (!S.m || !S.tw) return;
    S.Z.cx -= dx / (S.m.kx * S.tw); S.Z.cy -= dy / (S.m.ky * S.tw / R); cadrer();
  }
  function majBoutonsZoom(){
    var z = S.Z.z, a = document.activeElement;
    vMoins.disabled = z <= 1.001; vPlus.disabled = z >= S.zMax - .001; vAjuster.hidden = z <= 1.001;
    geste.setAttribute('data-zoome', z > 1.001 ? '1' : '0');
    if (a && (a.disabled || a.hidden)) try { geste.focus({ preventScroll: true }); } catch(e) {}
  }
  function montrerAide(){
    vAide.textContent = TACTILE ? (T.visioAideTactile || '') : (T.visioAideSouris || '');
    vAide.classList.add('mtxr-on'); clearTimeout(S.aideT);
    S.aideT = setTimeout(function(){ vAide.classList.remove('mtxr-on'); }, 2500);
  }
  function clavierVisio(e){
    var k = e.key, a = document.activeElement;
    if ((k === 'Enter' || k === ' ') && a && a.tagName === 'BUTTON') return;
    if (k === '+' || k === '=' || k === 'Add'){ e.preventDefault(); zoomPar(1.25); }
    else if (k === '-' || k === '_' || k === 'Subtract' || k === '−'){ e.preventDefault(); zoomPar(.8); }
    else if (k === '0'){ e.preventDefault(); ajuster(); }
    else if (k === 'ArrowLeft'){ e.preventDefault(); deplacer(40, 0); }
    else if (k === 'ArrowRight'){ e.preventDefault(); deplacer(-40, 0); }
    else if (k === 'ArrowUp'){ e.preventDefault(); deplacer(0, 40); }
    else if (k === 'ArrowDown'){ e.preventDefault(); deplacer(0, -40); }
  }
  function brancherVisio(){
    /* ouvrir : un toucher (zoom ×1,5 là où l'on touche), un clic ou le clavier (vue entière), ou deux doigts posés */
    btOuvrir.addEventListener('pointerdown', function(e){
      S.ptOuvrir = { x: e.clientX, y: e.clientY, type: e.pointerType };
      if (e.pointerType !== 'touch') return;
      var now = Date.now(), d1 = S.doigt1;
      if (d1 && d1.id !== e.pointerId && now - d1.t < 400 && !d1.annule){ S.doigt1 = null; ouvrirVisio({ x: (d1.x + e.clientX) / 2, y: (d1.y + e.clientY) / 2 }); }
      else S.doigt1 = { x: e.clientX, y: e.clientY, t: now, id: e.pointerId };
    });
    btOuvrir.addEventListener('pointercancel', function(){ if (S.doigt1) S.doigt1.annule = true; });
    btOuvrir.addEventListener('pointerup', function(e){ if (S.doigt1 && S.doigt1.id === e.pointerId) S.doigt1 = null; });
    btOuvrir.addEventListener('click', function(e){
      var p = S.ptOuvrir; S.ptOuvrir = null;
      ouvrirVisio(e.detail && p ? p : null);  /* clavier (detail 0) : sans point */
    });
    vX.addEventListener('click', function(){ fermerVisio(); });
    vMoins.addEventListener('click', function(){ zoomPar(1 / 1.5); });
    vPlus.addEventListener('click', function(){ zoomPar(1.5); });
    vAjuster.addEventListener('click', ajuster);
    /* gestes : un doigt déplace, deux doigts zooment (aperçu immédiat sur l'iframe, validation en fin de geste) */
    geste.addEventListener('pointerdown', function(e){
      S.typeP = e.pointerType;
      if (!S.visio || (e.pointerType === 'mouse' && e.button !== 0)) return;
      try { geste.setPointerCapture(e.pointerId); } catch(x) {}
      P[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(P);
      if (ids.length === 1) G = { type: 'attente', id: e.pointerId, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, px: e.clientX, py: e.clientY };
      else if (ids.length === 2){
        if (G && G.type === 'pan') fond.classList.remove('mtxr-glisse');
        var a = P[ids[0]], b = P[ids[1]], m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        G = { type: 'pinch', d0: Math.max(10, Math.hypot(a.x - b.x, a.y - b.y)), m0: m, m: m, k: 1, hx: versHex(m.x, m.y) };
      }
    });
    geste.addEventListener('pointermove', function(e){
      var p = P[e.pointerId]; if (!p) return;
      p.x = e.clientX; p.y = e.clientY;
      if (!G) return;
      if (G.type === 'attente' || G.type === 'pan'){
        if (e.pointerId !== G.id) return;
        G.x = e.clientX; G.y = e.clientY;
        if (G.type === 'attente' && Math.hypot(G.x - G.x0, G.y - G.y0) > 6){ G.type = 'pan'; fond.classList.add('mtxr-glisse'); }
        if (G.type === 'pan') planifier(function(){ if (!G || G.type !== 'pan') return; var dx = G.x - G.px, dy = G.y - G.py; G.px = G.x; G.py = G.y; deplacer(dx, dy); });
      } else if (G.type === 'pinch'){
        var ids = Object.keys(P); if (ids.length < 2) return;
        var a = P[ids[0]], b = P[ids[1]];
        G.m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        G.k = borne(Math.hypot(a.x - b.x, a.y - b.y) / G.d0, .9 / S.Z.z, 1.1 * S.zMax / S.Z.z);
        planifier(function(){ if (G && G.type === 'pinch') apercuGeste(G.k, G.m0, G.m.x - G.m0.x, G.m.y - G.m0.y); });
      }
    });
    function finPointeur(e){
      if (!P[e.pointerId]) return;
      delete P[e.pointerId];
      if (!G) return;
      if (G.type === 'pinch'){ var g = G; G = null; valider(g.k, g.m, g.hx); return; }
      if (e.pointerId !== G.id) return;
      if (G.type === 'attente' && e.type === 'pointerup' && e.pointerType !== 'mouse'){
        var now = Date.now(), l = S.tap;
        if (l && now - l.t < 300 && Math.hypot(e.clientX - l.x, e.clientY - l.y) < 24){ S.tap = null; basculerZoom({ x: e.clientX, y: e.clientY }); }
        else S.tap = { t: now, x: e.clientX, y: e.clientY };
      }
      fond.classList.remove('mtxr-glisse'); G = null;
    }
    geste.addEventListener('pointerup', finPointeur);
    geste.addEventListener('pointercancel', finPointeur);
    geste.addEventListener('lostpointercapture', finPointeur);
    /* double clic à la souris seulement : au toucher, finPointeur gère déjà le double toucher */
    geste.addEventListener('dblclick', function(e){ if (S.visio && S.typeP === 'mouse') basculerZoom({ x: e.clientX, y: e.clientY }); });
    /* molette (et pincement au pavé tactile dans Chrome/Firefox : ctrlKey) ; validation 300 ms après le dernier cran */
    sceneIn.addEventListener('wheel', function(e){
      if (!S.visio) return;
      e.preventDefault();
      if (GS || nbP() > 1) return;
      var dy = e.deltaY * (e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? 400 : 1));
      if (!WH) WH = { k: 1, o: { x: e.clientX, y: e.clientY }, hx: versHex(e.clientX, e.clientY) };
      WH.k = borne(WH.k * Math.exp(-dy * (e.ctrlKey ? .01 : .0015)), 1 / S.Z.z, S.zMax / S.Z.z);
      apercuGeste(WH.k, WH.o, 0, 0);
      clearTimeout(WH.t); WH.t = setTimeout(function(){ var w = WH; WH = null; if (w && S.visio) valider(w.k, w.o, w.hx); }, 300);
    }, { passive: false });
    /* pincement au pavé tactile dans Safari sur Mac */
    sceneIn.addEventListener('gesturestart', function(e){
      if (!S.visio) return; e.preventDefault();
      if (TACTILE || nbP() > 0) return;
      var o = { x: e.clientX || centre().x, y: e.clientY || centre().y };
      GS = { k: 1, o: o, hx: versHex(o.x, o.y) };
    });
    sceneIn.addEventListener('gesturechange', function(e){
      if (!S.visio) return; e.preventDefault();
      if (!GS) return;
      GS.k = borne(e.scale || 1, .9 / S.Z.z, 1.1 * S.zMax / S.Z.z); apercuGeste(GS.k, GS.o, 0, 0);
    });
    sceneIn.addEventListener('gestureend', function(e){
      if (!S.visio) return; e.preventDefault();
      if (!GS) return; var g = GS; GS = null; valider(g.k, g.o, g.hx);
    });
  }

  /* ── pastilles du bas : sur mobile, le panier a une barre « Passer au paiement » fixée en bas : on se pose au-dessus ── */
  /* bannière de consentement aux cookies de Shopify (et sa fenêtre de préférences) visible : son rectangle, sinon null */
  function cookiesOuverts(){
    var l = document.querySelectorAll('#shopify-pc__banner, [id^="shopify-pc__prefs"]');
    for (var i = 0; i < l.length; i++){
      var r = l[i].getBoundingClientRect(); if (!r.width || !r.height) continue;
      var cs = getComputedStyle(l[i]); if (cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0) return r;
    }
    return null;
  }
  /* bannière annoncée par Shopify mais pas encore dessinée (premières secondes de la visite) */
  function cookiesAttendus(){
    try { var cp = window.Shopify && Shopify.customerPrivacy; return !!(cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() && !document.getElementById('shopify-pc__banner')); } catch(e) { return false; }
  }
  function placer(){
    var h = 0, bar = document.querySelector('.mtc-barre, .mt-cart-checkout');
    if (bar){
      var cs = getComputedStyle(bar), r = bar.getBoundingClientRect();
      if (cs.position === 'fixed' && cs.display !== 'none' && r.height > 0 && r.bottom >= window.innerHeight - 2 && r.top < window.innerHeight) h = window.innerHeight - r.top;
    }
    /* la bannière cookies passe avant : la pastille de rappel attend qu'on y ait répondu (elle ne cache jamais « Refuser »),
       un avis se pose au-dessus d'elle */
    var ck = cookiesOuverts();
    Array.prototype.forEach.call(document.querySelectorAll('.mtxr-rappel.mtxr-on'), function(x){
      var avisX = x.classList.contains('mtxr-avis');
      x.classList.toggle('mtxr-sous-cookies', !!ck && !avisX);
      x.style.bottom = (ck && avisX ? Math.max(h, window.innerHeight - ck.top) + 12 : h + 14) + 'px';
    });
    clearTimeout(S.ckT); if (ck && document.querySelector('.mtxr-rappel.mtxr-on')) S.ckT = setTimeout(placer, 1000);
    /* barre fixe (mobile) : la pastille de rappel se pose dans un bandeau collé au-dessus de la barre, et la marge basse
       de la page grandit d'autant : le contenu (le « Sous-total »…) s'arrête au-dessus d'elle, jamais dessous */
    var rp = (h > 0 && rappel && rappel.classList.contains('mtxr-on') && !rappel.classList.contains('mtxr-sous-cookies')) ? rappel : null;
    var dh = rp ? Math.round(rp.offsetHeight + 24) : 0, de = document.documentElement;
    if (rp && !dock){ dock = el('div', 'mtxr-dock'); dock.setAttribute('aria-hidden', 'true'); document.body.appendChild(dock); }
    if (dock){ dock.classList.toggle('mtxr-on', !!rp); if (rp){ dock.style.bottom = (h - 1) + 'px'; dock.style.height = (dh + 1) + 'px'; } }
    de.classList.toggle('mtxr-dock-on', !!rp);
    if (rp) de.style.setProperty('--mtxr-dock-h', dh + 'px'); else de.style.removeProperty('--mtxr-dock-h');
    /* le bouton WhatsApp (mt-whatsapp-contact) se règle sur --mt-dock-bottom : on le remonte aussi au-dessus de la barre */
    var rs = document.documentElement.style;
    if (h > 0) rs.setProperty('--mt-dock-bottom', (h + 14) + 'px'); else rs.removeProperty('--mt-dock-bottom');
  }
  var placerR = 0;
  function placerBientot(){ if (placerR) return; placerR = requestAnimationFrame(function(){ placerR = 0; placer(); }); }
  window.addEventListener('scroll', placerBientot, { passive: true });
  window.addEventListener('resize', placerBientot);
  placer(); setTimeout(placer, 800); setTimeout(placer, 2500);
  function avis(txt){ if (!txt) return; var a = el('div', 'mtxr-rappel mtxr-on mtxr-avis', txt); a.setAttribute('role', 'status'); document.body.appendChild(a); placer(); setTimeout(placer, 600); setTimeout(function(){ if (a.parentNode) a.parentNode.removeChild(a); }, 9000); }

  /* ── garde « jamais seule » : la remise de 8,90 € s'applique au produit d'offre sans condition côté Shopify
     (une condition « Achetez X » bloquerait la 2ᵉ tomette −20 %) ; c'est donc le panier qui retire l'offre
     quand il ne reste aucune pièce de la collection « remise interne » ── */
  /* ELIG vient du rendu de la page (types et étiquette) ; on le complète avec le type des lignes de /cart.js,
     lu à la racine donc en français : une pièce ajoutée depuis, ou une page anglaise au type traduit */
  var ELIG = String(C.eligibles || '').split(',').filter(Boolean).map(Number);
  var TYPES = /^(Tomette personnalisée|Personalised terracotta tile|Personalised decorative tile)$/;
  function eligibles(cart){ return (cart.items || []).filter(function(i){ return i.product_id !== O.productId && (ELIG.indexOf(i.product_id) >= 0 || TYPES.test(i.product_type || '')); }); }
  function garde(cart){
    if (!aLOffre(cart) || eligibles(cart).length) return Promise.resolve(false);
    var u = {}; cart.items.forEach(function(i){ if (i.product_id === O.productId) u[i.key] = 0; });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: u }) })
      .then(function(r){ if (!r.ok) return false; ecrireS('mtxRoulette:retiree', '1'); location.reload(); return true; })['catch'](function(){ return false; });
  }
  var gardeT = null;
  document.addEventListener('cart:update', function(){
    if (S.ajout) return;
    clearTimeout(gardeT);
    gardeT = setTimeout(function(){ lirePanier().then(garde)['catch'](function(){}); }, 400);
  });

  /* ── démarrage : la bulle se monte invisible (l'aperçu se prépare pendant le délai), puis s'ouvre ── */
  function nlOuverte(){ return !!document.querySelector('dialog[open].mtnl-dialog, dialog[open][id^="mtnl"]'); }
  /* titres et prix en Instrument Serif : la bulle ne s'ouvre qu'une fois la police là (2,5 s au plus),
     sinon le titre et le prix changent de dessin sous les yeux (ou restent en police de secours) */
  function policesBulle(){
    var fs = document.fonts; if (!fs || typeof fs.load !== 'function') return Promise.resolve();
    if (!S.polP) S.polP = Promise.all([fs.load('400 44px "Instrument Serif"', '13 € 2'), fs.load('italic 400 24px "Instrument Serif"', 'Camille')])['catch'](function(){});
    return Promise.race([S.polP, new Promise(function(r){ setTimeout(r, 2500); })]);
  }
  function monterBientot(){
    policesBulle(); /* le téléchargement de la police part pendant le délai */
    if (window.requestIdleCallback) requestIdleCallback(function(){ construire(); }, { timeout: 1500 });
    else setTimeout(construire, 1200);
  }
  lirePanier().then(function(cart){
    if (!cart || !cart.items) return;
    if (lireS('mtxRoulette:retiree') === '1'){ ecrireS('mtxRoulette:retiree', ''); avis(f(T.retiree, { n: '', p: O.prix })); }
    if (!cart.items.length) return;
    var autres = eligibles(cart);
    if (aLOffre(cart)){
      garde(cart).then(function(retiree){
        if (retiree || lireS('mtxRoulette:rep') === '1') return;
        reparer(cart).then(function(ok){ if (ok){ ecrireS('mtxRoulette:rep', '1'); location.reload(); } });
      });
      return;
    }
    if (!actif || !autres.length) return;
    return fetch(SRC, { cache: 'force-cache' }).then(function(r){ return r.json(); }).then(function(j){
      var data = {}; (j.prenoms || []).forEach(function(p){ data[norm(p.n)] = { n: p.n, p: p.p || [] }; });
      S.noms = prenomsDuPanier(cart, data);
      if (!S.noms.length) return;
      S.nom = S.noms[0];
      if (lireS(CLE) === '1' && !test){ montrerRappel(); return; }
      monterBientot();
      var essais = 0, attenteCk = 0;
      setTimeout(function attendre(){
        if (nlOuverte() && essais++ < 40){ setTimeout(attendre, 1000); return; }
        /* jamais par-dessus la bannière cookies : on attend la réponse du visiteur (ou, si Shopify l'annonce
           sans la dessiner, quelques secondes au plus) */
        if (cookiesOuverts() || (cookiesAttendus() && attenteCk++ < 6)){ setTimeout(attendre, 1000); return; }
        policesBulle().then(ouvrir);
      }, C.delai || 3500);
    });
  })['catch'](function(){});
})();
